import productManagerStore from './src/store'

const ProductManager = () => import(/* webpackChunkNmae: 'member-portal' */ './src/components/ProductManager')

const install = function(Vue, options) {
  if (!options.store) {
    throw new Error('Please register the Product Manager Plugin by passing a Vuex Store')
  }
  options.store.registerModule('productmanager', productManagerStore, { preserveState: options.store.state.productmanager !== undefined })
}

export default {ProductManager, install}
